import { View } from 'react-native';

export default function Spacer({ height = 16 }){
  return (
    <View style={{ height }} />
  );
};